module.exports = __webpack_public_path__ + "static/media/login_bottom.eba59ad1.svg";